<!--
Author: TangChen
Date: 2019-01-18
Desc: 恢复定投基金，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-general-recovery bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/gfund' }">
                    基金定投
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <plan-buy v-if="fund.fundcode" :general-fund="fund" :wisdom="wisdom" action="2" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import planBuy from "@/components/fund/planBuy";
export default {
    name: "GeneralRecovery",
    components: {
        planBuy
    },
    mixins: [mixin],
    data () {
        return {
            fund: {},
            wisdom: false
        };
    },
    mounted () {
        const _fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        if (_fund.planflag === "2" || _fund.planflag === "6") {
            this.wisdom = true;
        }
        this.fund = _fund;
    },
    methods: {
    }
};
</script>
<style lang="scss">
  @import '../../assets/css/varibles';
  .bizcomp-general-recovery {
    padding-bottom: 30px;
  }
</style>
